import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes, faCalendar } from '@fortawesome/free-solid-svg-icons';
import ReactDatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { registerLocale } from 'react-datepicker';
import fr from 'date-fns/locale/fr';
import moment from 'moment';
import './reschedule-date-modal.css';

registerLocale('fr', fr);

/**
 * Modale pour replanifier des commandes vers une autre date
 */
export default function RescheduleDateModal({
  isOpen,
  onClose,
  unassignedCount,
  onReschedule,
  isRescheduling,
}) {
  const [selectedDate, setSelectedDate] = useState(null);

  if (!isOpen) return null;

  const handleReschedule = () => {
    if (selectedDate) {
      onReschedule(selectedDate);
    }
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-container reschedule-modal" onClick={(e) => e.stopPropagation()}>
        {/* En-tête */}
        <div className="modal-header">
          <div>
            <h2 className="modal-title">Replanifier les commandes</h2>
            <p className="modal-subtitle">
              <strong>{unassignedCount}</strong> commande(s) non affectée(s) seront déplacées vers la date sélectionnée
            </p>
          </div>
          <button className="modal-close-btn" onClick={onClose} disabled={isRescheduling}>
            <FontAwesomeIcon icon={faTimes} />
          </button>
        </div>

        {/* Corps de la modale */}
        <div className="modal-body">
          <div className="reschedule-content">
            <div className="date-picker-section">
              <label className="date-picker-label">
                <FontAwesomeIcon icon={faCalendar} className="calendar-icon" />
                Nouvelle date de livraison
              </label>
              <ReactDatePicker
                selected={selectedDate}
                onChange={(date) => setSelectedDate(date)}
                locale="fr"
                dateFormat="dd/MM/yyyy"
                minDate={new Date()}
                disabled={isRescheduling}
                inline
              />
            </div>

            {selectedDate && (
              <div className="selected-date-info">
                <p className="info-text">
                  Les <strong>{unassignedCount} commande(s)</strong> seront déplacées vers le{' '}
                  <strong>{moment(selectedDate).format('dddd D MMMM YYYY')}</strong>
                </p>
              </div>
            )}
          </div>
        </div>

        {/* Pied de page */}
        <div className="modal-footer">
          <button className="btn-secondary" onClick={onClose} disabled={isRescheduling}>
            Annuler
          </button>
          <button
            className="btn-primary"
            onClick={handleReschedule}
            disabled={!selectedDate || isRescheduling}
          >
            {isRescheduling ? 'Replanification en cours...' : 'Replanifier'}
          </button>
        </div>
      </div>
    </div>
  );
}

